(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .controller('AccessTokenDetailController', AccessTokenDetailController);

    AccessTokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AccessToken'];

    function AccessTokenDetailController($scope, $rootScope, $stateParams, previousState, entity, AccessToken) {
        var vm = this;

        vm.accessToken = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('c3WebApp:accessTokenUpdate', function(event, result) {
            vm.accessToken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
